import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white whitespace-nowrap">
                韩漫画网
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              韩漫免费在线阅读平台，提供下拉式漫画阅读体验。每日更新最新韩漫，涵盖恋爱、奇幻、动作等多种类型。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(1, 7).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">全部分类</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@hanmanhua.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>上海市浦东新区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {currentYear} 韩漫画网. 本站所有漫画均来自互联网，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 text-sm text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}